import { Alert } from 'antd';
import { MODULES_ITEMS } from 'utils/constants';

const WarningMissingParticipants = ({ cycle }) => {
  const missingManagers = cycle.participants.filter((p) => !p.manager);
  const hasManagerReviewModule = cycle.modules.find(
    (m) => m.type === MODULES_ITEMS.DOWNWARD.type
  );
  const hasUpwardReviewModule = cycle.modules.find(
    (m) => m.type === MODULES_ITEMS.UPWARD.type
  );
  const hasPeerReviewModule = cycle.modules.find(
    (m) => m.type === MODULES_ITEMS.PEER.type
  );
  const missingReports = cycle.participants.filter(
    (p) => !p.reports || p.reports.length === 0
  );
  const missingPeers = cycle.participants.filter(
    (p) => !p.peers || p.peers.length === 0
  );
  const hasCycleManagerButMissingManager =
    hasManagerReviewModule && missingManagers.length > 0;
  const hasCycleUpwardButMissingReport =
    hasUpwardReviewModule && missingReports.length > 0;
  const hasCyclePeerButMissingPeer =
    hasPeerReviewModule && missingPeers.length > 0;
  return (
    <div>
      {(hasCycleManagerButMissingManager ||
        hasCycleUpwardButMissingReport ||
        hasCyclePeerButMissingPeer) && (
        <div style={{ marginBottom: 12 }}>
          <Alert
            type={'warning'}
            showIcon={true}
            description={
              <div>
                {`Some participants are missing ${
                  hasCycleManagerButMissingManager ? 'managers' : ''
                }${
                  hasCycleManagerButMissingManager &&
                  hasCycleUpwardButMissingReport
                    ? ' or '
                    : ''
                }${hasCycleUpwardButMissingReport ? 'reports' : ''}${
                  hasCyclePeerButMissingPeer &&
                  (hasCycleManagerButMissingManager ||
                    hasCycleUpwardButMissingReport)
                    ? ' or '
                    : ''
                }${hasCyclePeerButMissingPeer ? 'peers' : ''}.`}
                <div>Make sure to add them before sending the cycle.</div>
              </div>
            }
          />
        </div>
      )}
    </div>
  );
};

export default WarningMissingParticipants;
